export default (maxDecimalPlaces, value) => {
  const regexp = new RegExp(`^\\d*(,|.)?\\d{0,${maxDecimalPlaces}}$`, 'g');

  return value.match(regexp);
};
